import chroma from 'chroma-js';
import { GoalType } from '../graphql/generated';

const customColorScale = chroma
    .scale(['#40445A', '#4B5D5F'])
    .mode('hcl')
    .colors(2);

const untargetedColorScale = chroma
    .scale(['#6FBC7A', '#58B085', '#66A8A0'])
    .mode('hcl')
    .colors(3);

const targetedColorScale = chroma
    .scale(['#8D8EEA', '#35A3D9'])
    .mode('hcl')
    .colors(11);

export const colorsByGoalType: Record<
    GoalType,
    { primary: string; secondary: string }
> = {
    CASH_MANAGEMENT: {
        primary: untargetedColorScale[0],
        secondary: untargetedColorScale[1],
    },
    GENERAL_INVESTING: {
        primary: untargetedColorScale[1],
        secondary: untargetedColorScale[2],
    },
    RETIREMENT: {
        primary: targetedColorScale[0],
        secondary: targetedColorScale[1],
    },
    HOME_DOWN_PAYMENT: {
        primary: targetedColorScale[1],
        secondary: targetedColorScale[2],
    },
    EMERGENCY_FUND: {
        primary: targetedColorScale[2],
        secondary: targetedColorScale[3],
    },
    PAY_OFF_DEBT: {
        primary: targetedColorScale[3],
        secondary: targetedColorScale[4],
    },
    VACATION: {
        primary: targetedColorScale[4],
        secondary: targetedColorScale[5],
    },
    COLLEGE: {
        primary: targetedColorScale[5],
        secondary: targetedColorScale[6],
    },
    CAR: {
        primary: targetedColorScale[6],
        secondary: targetedColorScale[7],
    },
    WEDDING: {
        primary: targetedColorScale[7],
        secondary: targetedColorScale[8],
    },
    BABY: {
        primary: targetedColorScale[8],
        secondary: targetedColorScale[9],
    },
    DAYCARE: {
        primary: targetedColorScale[9],
        secondary: targetedColorScale[10],
    },
    CUSTOM: {
        primary: customColorScale[0],
        secondary: customColorScale[1],
    },
};
